<script lang="ts" setup>
import type { NumericFilter } from '~/types/Catalog';

const props = defineProps<{ filter: NumericFilter }>();

const filterValue = ref(props.filter.value ?? '');
const route = useRoute();

async function handleFilterChange() {
  if (!filterValue.value) return;
  if (route.query.page) delete route.query.page;

  const filterSlug = `filter[${props.filter.slug}]`;

  await navigateTo({
    path: route.path,
    query: { ...route.query, [filterSlug]: filterValue.value },
  });
}

const { catalogPageIsLoading } = storeToRefs(useCatalogStore());
</script>

<template>
  <div class="numeric-filter">
    <InputField
      v-model="filterValue"
      :name="filter.slug"
      :placeholder="filter.placeholder"
      class="flex-grow"
      type="number"
      @submit="handleFilterChange"
    />

    <TheBtn
      :is-loading="catalogPageIsLoading"
      color="outline"
      size="md"
      @click="handleFilterChange"
    >
      {{ filter.button_text }}
    </TheBtn>
  </div>
</template>

<style lang="scss">
.numeric-filter {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: $text-sm;
}
</style>
